import { ChevronLeft, ChevronRight, List } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PlayerMobileNavProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onOpenContents: () => void;
}

export function PlayerMobileNav({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  onOpenContents,
}: PlayerMobileNavProps) {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 z-40">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-3 h-16">
          <button
            onClick={onOpenContents}
            className="flex flex-col items-center justify-center space-y-1 py-1 text-gray-600 dark:text-gray-300"
          >
            <List className="h-5 w-5" />
            <span className="text-xs">Contents</span>
          </button>
          <button
            onClick={onPrevious}
            disabled={!hasPrevious}
            className={cn(
              'flex flex-col items-center justify-center space-y-1 py-1',
              !hasPrevious
                ? 'opacity-30 cursor-not-allowed'
                : 'text-gray-600 dark:text-gray-300'
            )}
          >
            <ChevronLeft className="h-5 w-5" />
            <span className="text-xs">Previous</span>
          </button>
          <button
            onClick={onNext}
            disabled={!hasNext}
            className={cn(
              'flex flex-col items-center justify-center space-y-1 py-1',
              !hasNext
                ? 'opacity-30 cursor-not-allowed'
                : 'text-gray-600 dark:text-gray-300'
            )}
          >
            <ChevronRight className="h-5 w-5" />
            <span className="text-xs">Next</span>
          </button>
        </div>
      </div>
    </div>
  );
}
